import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94f2bb5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-inputs" }
const _hoisted_2 = { key: 0 }

import TextLabel from "@/components/UI/TextLabel.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeInputFieldsWrapper',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    (_ctx.$slots.legend)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_2, [
          _createVNode(TextLabel, { class: "shape-inputs__legend" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "legend")
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})